module.exports = __webpack_public_path__ + "static/SLFCspread-5-774c529418017b0dc959d9cceda96857.jpg";